import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { removeAllCookies } from 'api/utility/localStorageFunctions'
import { getMsalInstance } from 'authConfig'
import axios from 'axios'
import Cookies from 'js-cookie'
import { authAPI } from '../api/authAPI'
import { getMsalPostLogoutRedirectUri } from 'helpers/logoutRedirect'

export const login: any = createAsyncThunk(
  'auth/login',
  async ({ email, password }: any, { rejectWithValue }) => {
    try {
      const response = await authAPI.login(email, password)
      localStorage.setItem('user', response.data.token)
      return {
        token: response.data.token,
      }
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const logout: any = createAsyncThunk(
  'auth/logout',
  async (self, { rejectWithValue }) => {
    const msalInstance = await getMsalInstance()
    try {
      removeAllCookies()

      Cookies.remove('loginPolicy')

      localStorage.removeItem('user')

      msalInstance.logoutRedirect({
        postLogoutRedirectUri: getMsalPostLogoutRedirectUri(),
        extraQueryParameters: {
          logonLocation: localStorage.getItem('logonLocation') ?? 'jyrney',
        },
      })
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const resetPassword: any = createAsyncThunk(
  'auth/resetPassword',
  async ({ token, email, password }: any, { rejectWithValue }) => {
    try {
      const response = await authAPI.resetPassword(email, password, token)
      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const forgotPassword: any = createAsyncThunk(
  'auth/forgotPassword',
  async (email, { rejectWithValue }) => {
    try {
      const response = await authAPI.forgotPassword(email)
      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: '',
    user: {
      id: '',
      roleId: '',
      clientId: '',
      dashboard: {},
    },
    b2cPolicy: '',
    email: '',
    error: null,
  },
  reducers: {
    setB2CPolicy(state: any, action) {
      state.b2cPolicy = action.payload.b2cPolicy
      state.email = action.payload.email
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.fulfilled, (state: any, action) => {
      state.token = action.payload.token
      state.user = action.payload.user
      state.client = action.payload.client
    })
    builder.addCase(login.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload.error
      } else {
        state.error = action.error
      }
    })
    builder.addCase(logout.fulfilled, (state: any) => {
      state.token = ''
      state.user = {}
    })
    builder.addCase(logout.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload.error
      } else {
        state.error = action.error
      }
    })
    builder.addCase(resetPassword.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload.error
      } else {
        state.error = action.error
      }
    })
    builder.addCase(forgotPassword.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload.error
      } else {
        state.error = action.error
      }
    })
  },
})

export const { setB2CPolicy } = authSlice.actions

export default authSlice.reducer
